import { scrollToElementById } from '@/utils';

/**
 * Quick Link に使用する
 */
export default ({ linkHandle, id }) => {
  scrollToElementById(id);
  if (linkHandle) linkHandle(id);
};



// WEBPACK FOOTER //
// ./src/services/quickLink.js